import { AutorisationAggregate } from '../../../../../aggregats/autorisation/autorisation.aggregate';
import { AutorisationsAggregate } from '../../../../../aggregats/autorisation/autorisations.aggregate';
import { SousMenuItemAggregate } from '../../../../../aggregats/menu/sous-menu-item.aggregate';
import { FonctionLogicielle } from '../../../../fonctions-logicielle-constantes';
import { EparcoursPath } from '../../eparcours-path';

export const matieresSousmenuItem = new SousMenuItemAggregate(
  'Modules',
  `/${EparcoursPath.root.MATIERES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Modules)]),
);

export const ressourcesSousMenuItem = new SousMenuItemAggregate(
  'Ressources',
  `/${EparcoursPath.root.RESSOURCES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Ressources)]),
);

export const articlesSousMenuItem = new SousMenuItemAggregate(
  'Articles',
  `/${EparcoursPath.root.ARTICLES}`,
  new AutorisationsAggregate([new AutorisationAggregate(FonctionLogicielle.Articles)]),
);
